<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.806 6.8C14.806 5.52696 14.2997 4.30606 13.3984 3.40589C12.4971 2.50571 11.2746 2 10 2C8.72536 2 7.50293 2.50571 6.60163 3.40589C5.70032 4.30606 5.19398 5.52696 5.19398 6.8C5.19398 9.27215 4.56957 10.9648 3.87205 12.0843C3.28368 13.0287 2.9895 13.5009 3.00029 13.6326C3.01223 13.7785 3.04317 13.8341 3.16085 13.9213C3.26713 14 3.74623 14 4.70445 14H15.2956C16.2538 14 16.7329 14 16.8392 13.9213C16.9568 13.8341 16.9878 13.7785 16.9997 13.6326C17.0105 13.5009 16.7163 13.0287 16.1279 12.0843C15.4304 10.9648 14.806 9.27215 14.806 6.8Z"
      stroke="currentColor"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.09585 17.2C8.57977 17.6979 9.21543 18 9.91161 18C10.6078 18 11.2435 17.6979 11.7274 17.2C12.3763 16.4365 12.6673 15.7754 13 14H7C7.15191 15.5551 7.29464 16.3634 8.09585 17.2Z"
      stroke="currentColor"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
